import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AgentDto } from '../../../../service/dto';
import { Callback } from '../../login.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../../service/auth.service';

@Component({
	selector: 'app-login-form',
	standalone: false,
	templateUrl: './login-form.component.html',
	styleUrl: './login-form.component.scss'
})
export class LoginFormComponent {
	@Input() agent!: AgentDto;
	@Output("doUpdateState") doUpdateState = new EventEmitter<Callback>();

	loginForm: FormGroup;
	showPassword = false;

	constructor(private fb: FormBuilder, private authService: AuthService) {
		this.loginForm = this.fb.group({
			username: ['', Validators.required],
			password: ['', Validators.required],
		});
	}

	togglePasswordVisibility(): void {
		this.showPassword = !this.showPassword;
	}

	onSubmit(): void {
		if (this.loginForm.valid) {
			this.authService.doAuthenticate(this.loginForm.get('username')!.value, this.loginForm.get('password')!.value, '')
			.subscribe(result => {

			})
		}
	}
	doForgotPassword(){
		this.doUpdateState.emit({mode: 'ForgotPassword'})
	}
}
